import { PinchZoom, LitElement, html, css } from '@hh/global.js'

class HHPinchZoom extends LitElement {
  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.initPinchZoom()
  }

  initPinchZoom() {
    const image = this.querySelector('div')
    if (!image) return
    setTimeout(() => {
      this.pinchZoomInstance = new PinchZoom(image)
    }, 1000)
  }

  render() {
    return html` <slot></slot> `
  }

  static styles = css`
    :host {
      background-color: var(--hh-color-brand-background);
      display: block;
      width: 100%;
      height: 100%;
    }
  `
}

customElements.define('hh-pinch-zoom', HHPinchZoom)
